<div class='row'>
    <div class='col-12 col-md-6 col-lg-8'>
        <h2 class='h3 mb-0' id='kpf-ueberschrift'>
            {{ getTitle(nachrichtFolder) }}
        </h2>
    </div>

    <div class='col-12 col-md-6 col-lg-4 ba-message-search'>
        <div class="sr-only" id="kpf-postfach-suche-hint">
            {{ 'mailbox.search-hint' | i18next:{count: anzahlNachrichten} }}
        </div>

        <label for='kpf-postfach-suche-input'>
            {{ 'mailbox.browse-folder'|i18next }}
        </label>

        <div class='input-group'>
            <input
                    type='text'
                    class='form-control'
                    id='kpf-postfach-suche-input'
                    (input)="onSearchInputChanged($event)"
                    maxLength='50'
                    [value]='searchInput'
                    aria-describedby="kpf-postfach-suche-hint"
            />

            @if (searchInput.length) {
                <button
                        type="button"
                        class="ba-icon ba-icon-x"
                        id="btn-delete-search"
                        [attr.aria-label]="'mailbox.clear-search' | i18next"
                        [title]="'mailbox.clear-search' | i18next"
                        (click)="setSearchInput('')">
                </button>
            } @else {
                <span class="ba-icon ba-icon-search-small input-group-text" aria-hidden="true"></span>
            }

        </div>
    </div>
</div>